export default __webpack_public_path__ + "static/media/rhce.852cfac3.jpg";